import { GetUserQuery } from "@/generated/graphql";
import { ErrorCode } from "@/libs/errors";
import { graphql, HttpResponse } from "msw";
import { MockUsers } from "./constants";

export const getUserHandler = graphql.query<GetUserQuery>(
  "getUser",
  ({ query, variables }) => {
    for (let value of MockUsers) {
      console.log(variables.sub, " : ", value.sub);
      if (variables.sub === value.sub) {
        return HttpResponse.json({
          data: {
            user: value,
          },
        });
      }
    }
    return HttpResponse.json({
      data: {
        user: null,
      },
      errors: [
        {
          extensions: {
            code: ErrorCode[ErrorCode.INTERNAL_SERVER_ERROR],
          },
        },
      ],
    });
  }
);
